import { useMutation, useQuery } from "@apollo/client";
import ReactTable from "react-table";
import { GET_MESSAGE_LIST } from "../queries";
import {
  Input,
  Row,
  Col,
  Collapse,
  Card,
  CardBody,
  CardHeader,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { useState, Fragment, useEffect } from "react";
import { GET_ALL_COLLABORATION_NEEDS } from "../queries";
import { DELETE_CSO_WISH, SUPPORTER_FIRST_MESSAGE } from "../mutations";
import HomepageIcon from "../assets/icon/homepage.png";
import styles from "../Table/index.module.scss";
import { Multiselect } from "react-widgets";
import { Link } from "react-router-dom";
import { sendGAEvent } from "../../../../utils";
import DissolveBadge from "../../../../components/DissolveBadge";
import { CHECK_USER_STATUS } from "../../../../queries";
import { useUserEmail } from "../../../../Layout/AppMain/LoginStatusContext";

export const statusChipStyle = {
  面談予定: {
    backgroundColor: "#D5D4FF",
    border: "1px solid #0500FF",
    color: "#0500FF",
  },
  問合せ中: {
    backgroundColor: "#FFD5D4",
    color: "#FF0000",
    border: "1px solid #FF0000",
  },
  面談終了: {
    backgroundColor: "#D6D6D6",
    color: "#495057",
    border: "1px solid #495057",
  },
  面談依頼中: {
    backgroundColor: "#BBFFAA6B",
    color: "#1D9200",
    border: "1px solid #1D9200",
  },
  連携中: {
    backgroundColor: "#75EBFF2B",
    color: "#44CAE1",
    border: "1px solid #44CAE1",
  },
  default: {
    backgroundColor: "#FFF09F",
    color: "#E4A400",
    border: "1px solid #e4a400",
  },
};

export const idealStartingTimeOptions = [
  { label: "未定", value: "未定" },
  { label: "1週間以内", value: "1週間以内" },
  { label: "1か月以内", value: "1か月以内" },
  { label: "3か月以内", value: "3か月以内" },
  { label: "6か月以内", value: "6か月以内" },
  { label: "7か月より先以降", value: "7か月より先以降" },
];

export const collaborationScaleOptions = [
  { label: "未定", value: "未定" },
  { label: "10万円以下", value: "10万円以下" },
  { label: "11～100万円以下", value: "11～100万円以下" },
  { label: "101～300万円以下", value: "101～300万円以下" },
  { label: "301～500万円以下", value: "301～500万円以下" },
  { label: "501～1000万円以下", value: "501～1000万円以下" },
  { label: "1001万円以上", value: "1001万円以上" },
];

const WishesCSO = () => {
  const {
    loading,
    data: rawData,
    refetch: refetchCsoList,
  } = useQuery(GET_MESSAGE_LIST);

  const [collapse, setCollapse] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [checkedOrgs, setCheckedOrgs] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [collabModalOpen, setCollabModalOpen] = useState({
    open: false,
    item: null,
  });
  const [reviewDataModal, setReviewDataModal] = useState(false);
  const [recommendationModal, setRecommendationModal] = useState(false);
  const data = rawData?.myCsoWishes?.edges?.map((edge) => {
    return edge.node;
  });

  // State for Mutation
  const [collaborationNeed, setCollaborationNeed] = useState([]);
  const [collaborationNeedName, setCollaborationNeedName] = useState([]);
  const [idealStartingTime, setIdealStartingTime] = useState("");
  const [collaborationScale, setCollaborationScale] = useState("");
  const [message, setMessage] = useState("");
  const [supporter, setSupporter] = useState();
  const [csoID, setCsoId] = useState();

  const { data: dataCollaborationNeeds } = useQuery(
    GET_ALL_COLLABORATION_NEEDS
  );

  let doropdownData = dataCollaborationNeeds?.allCollaborationNeeds.edges.map(
    (edge) => ({
      id: edge.node.intId,
      color: edge.node.title,
    })
  );

  const toggle = () => setDeleteModalOpen(!deleteModalOpen);
  const toggleReviewDataModal = () => setReviewDataModal(!reviewDataModal);
  // HERE

  const [
    deleteCsoWish,
    // { data: deletedCsoWish, loading: loadingDeleteCsoWish },
  ] = useMutation(DELETE_CSO_WISH);

  const handleCheckRow = (id) => {
    if (!id) return;
    if (checkedOrgs.includes(id))
      setCheckedOrgs(checkedOrgs.filter((orgId) => orgId !== id));
    else setCheckedOrgs([...checkedOrgs, id]);
  };

  const handleDeleteCsoWish = () => {
    deleteCsoWish({
      variables: {
        csoWishId: selectedOrg.id,
      },
      onCompleted: () => {
        refetchCsoList();
      },
    });
    setSelectedOrg(null);
    setDeleteModalOpen(false);
  };

  const { data: checkUserStatus } = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });

  const canEdit =
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "can_edit" ||
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "CAN_EDIT";

  const toggleCollabModal = (data) => {
    if (!canEdit) return;
    setCsoId(data.cso.id);
    setCollabModalOpen({ open: !collabModalOpen.open, item: data });
  };

  const partnershipTableColumns = [
    {
      Header: "選択問合せ",
      accessor: "checkbox",
      width: 90,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "center", width: "70px" }}>
            <Input
              onChange={() => {
                handleCheckRow(row._original.id);
              }}
              checked={[...checkedOrgs].includes(row._original.id)}
              style={{ position: "relative", left: 10 }}
              type="checkbox"
            />
          </div>
        );
      },
    },

    {
      Header: "組織名",
      accessor: "name",
      width: 400,
      Cell: ({ row }) => {
        return (
          <div
            onClick={() => {
              toggleCollabModal(row._original);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {row._original.cso.name}
            {row._original.cso.isDissolve && <DissolveBadge />}
          </div>
        );
      },
    },
    {
      Header: "ステータス",
      accessor: "status",
      width: 150,
      Cell: ({ row }) => {
        const status = row._original.readableSupporterStatus;
        const hasNewMessage = row?._original?.supporterHasNewMessage;
        return (
          <div
            style={{
              ...(statusChipStyle[status] || statusChipStyle["default"]),
              fontSize: "9px",
              padding: "4px 7px",
              borderRadius: "18px",
              whiteSpace: "nowrap",
              margin: "auto",
              position: "relative",
            }}
          >
            候補
            {hasNewMessage && (
              <div
                style={{
                  position: "absolute",
                  top: "-3px",
                  right: "0",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#FF0000",
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      Header: "面談日時",
      accessor: "interview_date",
      width: 200,
      Cell: ({ row }) => {
        return (
          <>
            <div
              style={{
                fontSize: "9px",
                padding: "4px 7px",
                borderRadius: "18px",
                whiteSpace: "nowrap",
                margin: "auto",
                position: "relative",
                textAlign: "center",
                width: "100%",
              }}
            >
              -
            </div>
          </>
        );
      },
    },
    {
      Header: "組織情報",
      accessor: "org_info",
      width: 75,
      Cell: ({ row }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "75px",
            }}
          >
            {row._original.cso.isPublic ? (
              <Link
                to={`/dashboards/plofile-organization/${row._original.cso.pk}`}
                target="_blank"
                rel="noreferrer"
              >
                <i
                  className="pe-7s-home"
                  style={{ fontSize: "20px", color: "#000" }}
                ></i>
              </Link>
            ) : (
              <div
                role="button"
                style={{
                  color: "#545cd8",
                }}
                onClick={() => {
                  alert("本組織の情報は非公開となっています");
                }}
              >
                <i
                  className="pe-7s-home"
                  style={{ fontSize: "20px", color: "#000" }}
                ></i>
              </div>
            )}
          </div>
        );
      },
    },
    {
      Header: "HP",
      accessor: "homepage",
      width: 75,
      Cell: ({ row }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "75px",
            }}
          >
            <a
              href={row._original.cso.homepage}
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="pe-7s-link"
                style={{ fontSize: "20px", color: "#000" }}
              ></i>
            </a>
          </div>
        );
      },
    },
    {
      Header: "",
      width: 45,
      Cell: ({ row }) => {
        return (
          <>
            {canEdit && (
              <button
                type="button"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  width: "",
                  fontSize: "12px",
                }}
                onClick={() => {
                  setSelectedOrg(row._original);
                  setDeleteModalOpen(true);
                }}
              >
                &#x2715;
              </button>
            )}
          </>
        );
      },
    },
  ];

  const [createCollaboration, { loading: loadingCreateCollaboration }] =
    useMutation(SUPPORTER_FIRST_MESSAGE, {
      onCompleted: () => {
        refetchCsoList();
      },
    });

  const handleSubmit = async () => {
    await createCollaboration({
      variables: {
        supporter: supporter,
        message: message,
        idealStartingTime: idealStartingTime,
        collaborationScale: collaborationScale,
        cso: csoID,
        collaborationNeeds: collaborationNeed,
      },
    })
      .then((response) => {
        setReviewDataModal(false);
        setCollabModalOpen({ open: false, item: null });
        setRecommendationModal(true);
      })
      .catch((error) => {
        setReviewDataModal(false);
        setRecommendationModal(false);
        alert(error.message);
        console.log(error);
      });
  };

  useEffect(() => {
    if (rawData?.allSupporters?.edges[0].node.id) {
      setSupporter(rawData?.allSupporters?.edges[0].node.id);
    }
  }, [rawData]);

  useEffect(() => {
    if (collabModalOpen.open) {
      setCollaborationNeed([]);
      setCollaborationNeedName([]);
      setIdealStartingTime(idealStartingTimeOptions[0].value);
      setCollaborationScale(collaborationScaleOptions[0].value);
      setMessage("");
    }
  }, [collabModalOpen.open]);

  useEffect(() => {
    sendGAEvent(
      "pageview",
      "/#/dashboards/organization-partnership/message_tab"
    );
  }, []);

  return (
    <Fragment>
      <Row
        className="mt-3"
        style={{
          overflowX: "auto",
        }}
      >
        <Col xs={12}>
          {/* <button
            style={{
              padding: "6px 16px",
              borderRadius: "4px",
              backgroundColor: "#BDBDBD",
              color: "#fff",
              border: "none",
              marginLeft: "0px",
            }}
            type="button"
            onClick={() => {
              alert("実装中の機能です、利用開始まで今しばらくお待ちください");
            }}
          >
            アンケート
          </button> */}
          <button
            style={{
              padding: "6px 16px",
              borderRadius: "4px",
              backgroundColor: collapse ? "#44CAE1" : "#BDBDBD",
              color: "#fff",
              border: "none",
              // marginLeft: "10px",
            }}
            onClick={() => setCollapse(!collapse)}
          >
            登録済みCSO
          </button>
        </Col>
        {collapse && (
          <Col xs={12}>
            <div className="mt-3">
              <ReactTable
                loading={loading}
                defaultPageSize={10}
                className="-striped -highlight"
                previousText="前へ"
                nextText="次へ"
                pageText=""
                ofText="of"
                rowsText=""
                style={{ cursor: "pointer" }}
                data={data}
                columns={partnershipTableColumns}
              />
            </div>
          </Col>
        )}
      </Row>
      <div className={styles["delete-modal-container"]}>
        <Modal
          isOpen={deleteModalOpen}
          toggle={toggle}
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["modal-content"]}
        >
          <ModalHeader
            toggle={toggle}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody
            style={{
              padding: "16px 40px 40px 40px",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {`${selectedOrg?.cso?.name} を`}
              <br />
              <div>連携候補から削除しますか？</div>
            </div>
            <Button
              style={{
                width: "100%",
                backgroundColor: "#EB5757",
                border: "none",
                marginTop: "32px",
                padding: "13px 53px",
              }}
              onClick={handleDeleteCsoWish}
            >
              削除
            </Button>
          </ModalBody>
        </Modal>
      </div>

      <div className={styles["collab-modal-container"]}>
        <Modal
          isOpen={collabModalOpen.open}
          className={styles["modal-content-collab"]}
          backdropClassName={styles["reverted-backdrop"]}
        >
          <ModalHeader
            toggle={() => toggleCollabModal(collabModalOpen.item)}
            className={styles["modal-header"]}
            style={{
              textAlign: "center",
              margin: "40px auto -60px auto",
            }}
          >
            <span className="ema__modal_title">メッセージ</span>
            <p>{""}</p>
            <p style={{ fontSize: "0.88rem" }}>
              「連携構築」に向けて、あなたの連携ニーズ等を入力しましょう。
            </p>
          </ModalHeader>
          <ModalBody
            style={{
              padding: "80px 40px 40px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Form>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Label for="entityType" className="mr-sm-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>連携ニーズ</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        backgroundColor: "#f7caca",
                        fontSize: "9px",
                        color: "#c92d2d",
                        borderRadius: "12px",
                        border: "1px solid #c92d2d",
                      }}
                    >
                      必須
                    </span>
                  </div>
                </Label>
                <Multiselect
                  dataKey="id"
                  textField="color"
                  data={doropdownData}
                  placeholder="連携ニーズ   "
                  // defaultValue={country.edges.map((ary) => ary.node.nameJp)}
                  // defaultValue={CountryDefaultVal}
                  onChange={(e) => {
                    setCollaborationNeed(e.map((ary2) => ary2.id));
                    setCollaborationNeedName(e.map((ary2) => ary2.color));
                  }}
                />
              </FormGroup>
              <FormGroup className="mt-3 mb-1 mr-sm-2 mb-sm-0">
                <Label for="idealStartingTime" className="mr-sm-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>連携を開始したい時期</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        backgroundColor: "#f7caca",
                        fontSize: "9px",
                        color: "#c92d2d",
                        borderRadius: "12px",
                        border: "1px solid #c92d2d",
                      }}
                    >
                      必須
                    </span>
                  </div>
                </Label>
                <Input
                  type="select"
                  name="idealStartingTime"
                  id="idealStartingTime"
                  onChange={(e) => setIdealStartingTime(e.target.value)}
                  placeholder="例) 半年以内に連携希望"
                >
                  {idealStartingTimeOptions.map((option) => {
                    return (
                      <option
                        selected={
                          option.value === idealStartingTime ? true : false
                        }
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    );
                  })}
                </Input>
              </FormGroup>
              <FormGroup className="mt-3 mb-1 mr-sm-2 mb-sm-0">
                <Label for="collaborationScale" className="mr-sm-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>連携規模(金額)</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        backgroundColor: "#f7caca",
                        fontSize: "9px",
                        color: "#c92d2d",
                        borderRadius: "12px",
                        border: "1px solid #c92d2d",
                      }}
                    >
                      必須
                    </span>
                  </div>
                </Label>
                <Input
                  type="select"
                  name="collaborationScale"
                  id="collaborationScale"
                  onChange={(e) => setCollaborationScale(e.target.value)}
                  placeholder="例) 300~500万円の予算で検討したい"
                >
                  {collaborationScaleOptions.map((option) => {
                    return (
                      <option
                        selected={
                          option.value === collaborationScale ? true : false
                        }
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    );
                  })}
                </Input>
              </FormGroup>
              <FormGroup className="mt-3 mb-1 mr-sm-2 mb-sm-0">
                <Label for="message" className="mr-sm-2">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span>メッセージ</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        backgroundColor: "#f7caca",
                        fontSize: "9px",
                        color: "#c92d2d",
                        borderRadius: "12px",
                        border: "1px solid #c92d2d",
                      }}
                    >
                      必須
                    </span>
                  </div>
                </Label>
                <Input
                  type="textarea"
                  name="message"
                  id="message"
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="連携内容、連携規模感(金銭以外）、特別な条件、その他メッセージがあればご記入ください。"
                />
              </FormGroup>
            </Form>
            <Button
              className="ema__btn__main__lg btn btn-secondary"
              style={{ marginLeft: "auto", marginTop: "16px" }}
              onClick={() => {
                setCollabModalOpen((prev) => {
                  return {
                    ...prev,
                    open: false,
                  };
                });
                toggleReviewDataModal();
              }}
              disabled={
                collaborationNeed?.length === 0 ||
                collaborationNeedName?.length === 0 ||
                !idealStartingTime ||
                !collaborationScale ||
                !message
              }
            >
              次へ
            </Button>
          </ModalBody>
          {/* <ModalFooter>
            
          </ModalFooter> */}
        </Modal>
      </div>

      <div className={styles["collab-modal-review"]}>
        <Modal
          isOpen={reviewDataModal}
          className={styles["modal-content-collab"]}
          backdropClassName={styles["reverted-backdrop"]}
        >
          <ModalHeader
            toggle={toggleReviewDataModal}
            className={styles["modal-header"]}
          >
            <span style={{ position: "absolute", left: "45%", top: "40px" }}>
              メッセージ
            </span>
          </ModalHeader>
          <ModalBody
            style={{
              padding: "80px 40px 40px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Form>
              <FormGroup>
                <Label>連携ニーズ</Label>
                <ul>
                  {collaborationNeedName.map((item) => (
                    <li>{item}</li>
                  ))}
                </ul>
              </FormGroup>
              <FormGroup>
                <Label>連携を開始したい時期</Label>
                <Input value={idealStartingTime} disabled />
              </FormGroup>
              <FormGroup>
                <Label>連携規模(金額)</Label>
                <Input value={collaborationScale} disabled />
              </FormGroup>
              <FormGroup>
                <Label>メッセージ</Label>
                <Input type="textarea" value={message} disabled />
              </FormGroup>
            </Form>
            <Button
              className="ema__btn__main__lg btn btn-secondary"
              style={{ marginLeft: "auto", marginTop: "16px" }}
              onClick={handleSubmit}
            >
              {loadingCreateCollaboration ? (
                <div>
                  <Spinner size="sm" color="light" />
                </div>
              ) : (
                "次へ"
              )}
            </Button>
          </ModalBody>
          {/* <ModalFooter>
            <Button color="primary" onClick={handleSubmit}>
              Next
            </Button>
          </ModalFooter> */}
        </Modal>
      </div>

      <div className={styles["collab-modal-review"]}>
        <Modal
          toggle={() => setRecommendationModal(false)}
          isOpen={recommendationModal}
          className={styles["modal-content-collab"]}
          backdropClassName={styles["reverted-backdrop"]}
        >
          <ModalHeader
            toggle={() => setRecommendationModal(false)}
            className={styles["modal-header"]}
          ></ModalHeader>
          <ModalBody>
            <div
              style={{
                color: "red",
                marginBottom: "10px",
                textAlign: "center",
                padding: "60px 50px 35px",
              }}
            >
              <div
                style={{
                  marginBottom: "24px",
                  position: "absolute",
                  top: "10px",
                  left: "45%",
                  color: "black",
                }}
              >
                送信完了
              </div>

              <div
                style={{
                  marginBottom: "55px",
                }}
              >
                CSOがプロフィールを確認するため、
                <br />
                情報をアップデートしましょう。
              </div>
              <Link
                style={{
                  padding: "9px 25px",
                  backgroundColor: "#44CAE1",
                  border: "none",
                  color: "white",
                  borderRadius: "5px",
                }}
                to="/dashboards/plofile-organization/"
              >
                {"情報をアップデートする"}
              </Link>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </Fragment>
  );
};

export default WishesCSO;
